import React from 'react';
import './ButtonBar.css';
import DrawButton from './DrawButton.jsx';
import myMapsConfig from './myMapsConfig.json';

//className={props.isEditing ? "fs-mymaps-button-bar fs-disabled" : "fs-mymaps-button-bar"}
const ButtonBar = (props) => {
  return (
    <div
      className={
        props.isEditing
          ? 'fs-mymaps-button-bar fs-disabled'
          : 'fs-mymaps-button-bar'
      }
    >
      <DrawButton
        title="Nacrtajte tačku na mapi"
        imageName="point.png"
        onClick={() => {
          props.onClick('Point');
        }}
        isActive={props.activeButton === 'Point' ? true : false}
      />
      <DrawButton
        title="Nacrtajte liniju na mapi (držite tipku Shift za slobodno crtanje)"
        imageName="polyline.png"
        onClick={() => {
          props.onClick('LineString');
        }}
        isActive={props.activeButton === 'LineString' ? true : false}
      />
      <DrawButton
        title="Nacrtajte poligon na mapi (držite tipku Shift za slobodno crtanje)"
        imageName="polygon.png"
        onClick={() => {
          props.onClick('Polygon');
        }}
        isActive={props.activeButton === 'Polygon' ? true : false}
      />
      <DrawButton
        title="Nacrtajte krug na mapi"
        imageName="circle.png"
        onClick={() => {
          props.onClick('Circle');
        }}
        isActive={props.activeButton === 'Circle' ? true : false}
      />
      <DrawButton
        title="Nacrtajte pravougaonik na mapi"
        imageName="rectangle.png"
        onClick={() => {
          props.onClick('Rectangle');
        }}
        isActive={props.activeButton === 'Rectangle' ? true : false}
      />
      <DrawButton
        title="Nacrtajte strelicu na mapi"
        imageName="arrow.png"
        onClick={() => {
          props.onClick('Arrow');
        }}
        isActive={props.activeButton === 'Arrow' ? true : false}
      />
      <DrawButton
        disabled={false}
        title="Dodajte tekst na mapi"
        imageName="text.png"
        onClick={() => {
          props.onClick('Text');
        }}
        isActive={props.activeButton === 'Text' ? true : false}
      />
      <DrawButton
        disabled={false}
        title="
        Dodajte nosivu liniju"
        imageName="compass.png"
        onClick={() => {
          props.onClick('Bearing');
        }}
        isActive={props.activeButton === 'Bearing' ? true : false}
        visible={myMapsConfig.showBearingButton}
      />
      <DrawButton
        disabled={false}
        title="
        Dodajte mjernu liniju"
        imageName="measure-tool.png"
        onClick={() => {
          props.onClick('Measure');
        }}
        isActive={props.activeButton === 'Measure' ? true : false}
        visible={myMapsConfig.showMeasureButton}
      />
      <DrawButton
        disabled={false}
        title="Brisanje stavki na mapi"
        imageName="eraser.png"
        onClick={() => {
          props.onClick('Eraser');
        }}
        isActive={props.activeButton === 'Eraser' ? true : false}
      />
      {/* <DrawButton
        disabled={true}
        title="Adjust Map Maps Settings"
        imageName="settings.png"
        onClick={() => {
          props.onClick("Settings");
        }}
        isActive={props.activeButton === "Settings" ? true : false}
      /> */}
      <DrawButton
        title="Otkaži trenutni alat za crtanje"
        imageName="none.png"
        onClick={() => {
          props.onClick('Cancel');
        }}
        isActive={props.activeButton === 'Cancel' ? true : false}
      />
    </div>
  );
};

export default ButtonBar;
